module.exports = __webpack_public_path__ + "img/checked_proposal.14454cae.png";